export default __webpack_public_path__ + "static/media/4.042d5c6f.jpg";